import React, { useState, useEffect } from "react";
import "../css/CustomTagInput.css"; // Add necessary styles

const CustomTagInput = ({ initialTags = [], onTagsChange }) => {
    const [tags, setTags] = useState(Array.isArray(initialTags) ? initialTags : []);
    const [inputValue, setInputValue] = useState("");

    // 🔥 Ensure tags update when initialTags changes
    useEffect(() => {
        if (Array.isArray(initialTags)) {
            console.log("Updating tags from initialTags:", initialTags);
            setTags(initialTags);
        }
    }, [initialTags]);

    useEffect(() => {
        onTagsChange(tags); // Convert tags array to string
    }, [tags]);

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && inputValue.trim() !== "") {
            e.preventDefault();
            setTags(prevTags => {
                const newTags = [...prevTags, inputValue.trim()];
                console.log("Tags After Adding:", newTags);
                return newTags;
            });
            setInputValue("");
        }
    };

    const handleRemoveTag = (index) => {
        setTags(tags.filter((_, i) => i !== index));
    };

    return (
        <div className="tag-container">
            <div className="tags">
                {tags.map((tag, index) => (
                    <span key={index} className="tag">
                        {tag}
                        <button className="remove-tag" onClick={() => handleRemoveTag(index)}>×</button>
                    </span>
                ))}
            </div>
            <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Enter tags and press Enter"
                className="tag-input"
            />
        </div>
    );
};

export default CustomTagInput;
